import config from '@config'
import { setCookieValue } from '@utils/cookie'

const {
  auth: {
    domain,
    audience,
    accountPath,
    clientID,
    lang,
    scope,
    state,
    responseType,
    authURL,
    loginPath,
    logoutPath,
    cookieDomain,
    loginCookie,
    logoutCookie,
  },
} = config

const loginStaticParams = {
  audience,
  scope,
  response_type: responseType,
  client_id: clientID,
  redirect_uri: `${authURL}${loginPath}`,
  lang,
  state,
}

const stringifiedLoginStaticParams = (
  Object.keys(loginStaticParams) as (keyof typeof loginStaticParams)[]
).reduce((acc, paramKey) => {
  return `${acc}${acc ? '&' : '?'}${paramKey}=${encodeURIComponent(
    loginStaticParams[paramKey]
  )}`
}, '')

const getClientId = () => {
  try {
    const cookie = document?.cookie
      ?.split(';')
      .find((cookieValue) => cookieValue.includes('_ga='))
      ?.split('=')

    return cookie?.[1]
  } catch (err) {}
}

const getLoginUrl = (
  extraParams?: Record<string, Parameters<typeof encodeURIComponent>[0]>
): string => {
  const gacid = getClientId()
  const params: Record<string, string> = {
    ...(gacid ? { gacid } : {}),
    ...extraParams,
  }
  const appendedParams = params
    ? Object.keys(params).reduce((acc, paramKey) => {
        return `${acc}&${paramKey}=${encodeURIComponent(params[paramKey])}`
      }, '')
    : ''

  return `https://${domain}/authorize${stringifiedLoginStaticParams}${appendedParams}`
}

const getLogoutUrl = (): string => {
  const params = {
    client_id: clientID,
    returnTo: `${authURL}${logoutPath}`,
  }

  const appendedParams = params
    ? (Object.keys(params) as (keyof typeof params)[]).reduce(
        (acc, paramKey) => {
          return `${acc}${acc ? '&' : '?'}${paramKey}=${encodeURIComponent(
            params[paramKey]
          )}`
        },
        ''
      )
    : ''

  return `https://${domain}/v2/logout${appendedParams}`
}

const getAccountUrl = (): string => {
  const params = {
    state,
  }

  const appendedParams = params
    ? (Object.keys(params) as (keyof typeof params)[]).reduce(
        (acc, paramKey) => {
          return `${acc}${acc ? '&' : '?'}${paramKey}=${encodeURIComponent(
            params[paramKey]
          )}`
        },
        ''
      )
    : ''

  return `${authURL}${accountPath}${appendedParams}`
}

const setLoginCookie = () => {
  setCookieValue({
    name: loginCookie,
    value: window.location.href,
    domain: cookieDomain,
  })
}

const setLogoutCookie = () => {
  const logoutRedirect = window.location.href

  setCookieValue({
    name: logoutCookie,
    value: logoutRedirect,
    domain: cookieDomain,
  })
}

export {
  getLoginUrl,
  getLogoutUrl,
  getAccountUrl,
  setLoginCookie,
  setLogoutCookie,
}
